import { Link } from 'react-router-dom';
import LegalLayout from '../components/LegalLayout';
import { COMPANY, LEGAL_UPDATED_TERMS } from '../constants/legal';

const DeliveryReturnsPage = () => (
  <LegalLayout
    testId="delivery-returns-page"
    title="Access, Delivery & Returns"
    description="How Gate 33 delivers digital training services, and how cancellations, rescheduling and refunds work."
    path="/legal/delivery-returns"
    updated={LEGAL_UPDATED_TERMS}
  >
    <p className="text-lg text-[#1A1A1A] leading-relaxed mb-8">
      Gate 33 sells digital services (live online training and mentorship). We do not ship physical goods. This page explains how access to our services is granted, and what happens if you need to reschedule or cancel.
    </p>

    <h2>1. Delivery of the 3-Day Online Training</h2>
    <ul>
      <li><strong>Format:</strong> live video sessions, delivered by the founder Nicolas Perot dos Santos.</li>
      <li><strong>Access:</strong> after your reservation, you receive your training contract to sign. Payment is requested once the 10-day withdrawal period has ended. The video-conference link is sent at least 48 hours before the start of your cohort.</li>
      <li>Sessions are not recorded and no course materials are sent. Cohorts are limited to 8 participants; one-to-one dates are available on request. The training ends with an individual final assessment with written feedback, a certificate of completion and a letter of reference.</li>
      <li><strong>Duration:</strong> three consecutive days, ~6 hours per day (subject to breaks and Q&A).</li>
      <li><strong>Requirements:</strong> a stable internet connection, a laptop or tablet, and a private and quiet environment during session hours.</li>
      <li><strong>Cohort dates:</strong> upcoming dates are always visible on the <Link to="/academy">Academy page</Link>.</li>
    </ul>

    <h2>2. Delivery of the Mentorship Programme</h2>
    <p>
      The Mentorship starts after payment, on dates agreed by email. Sessions take place on Google Meet and are scheduled around the trainer's flight roster, with written feedback within 24 hours of each session and WhatsApp support until the end of the programme.
    </p>

    <h2>3. Cancellation and rescheduling</h2>
    <p>Full terms are provided in our <Link to="/legal/terms">General Terms of Sale</Link>. In summary:</p>
    <ul>
      <li><strong>3-Day Online Training:</strong> 10 days from signature of the training contract (14 days if the contract is concluded at a distance); nothing is paid before the end of the 10 days. See the <Link to="/legal/withdrawal-form">Withdrawal Form</Link>.</li>
      <li><strong>Mentorship and other services:</strong> 14 days from purchase.</li>
      <li><strong>Rescheduling (up to 7 days before start).</strong> You may reschedule to a later cohort at no charge, subject to availability.</li>
      <li><strong>Late cancellation (less than 7 days before start).</strong> No refund; you may request one rescheduling to a future cohort within 12 months.</li>
      <li><strong>No-show.</strong> A client who fails to attend without prior notice will not be refunded and will not automatically receive a rescheduling offer.</li>
      <li><strong>Mentorship calls:</strong> reschedule at least 24 hours in advance; missed calls count as delivered; unused calls expire at the end of the 3 months.</li>
    </ul>

    <h2>4. Refunds</h2>
    <p>
      When applicable, refunds are made using the same payment method as the original transaction, within fourteen (14) days of receipt of the request. Instalments paid via PayPal or Klarna are refunded through the provider's own process.
    </p>

    <h2>5. Cancellation by Gate 33</h2>
    <p>
      {COMPANY.legalName} reserves the right to cancel or reschedule a cohort in case of force majeure, if the minimum number of participants is not reached, or if the trainer is unavailable due to his flight duty schedule. In such a case, the client will be offered a rescheduling to a future cohort or a full refund at their choice.
    </p>

    <h2>6. Physical shipping</h2>
    <p>
      Gate 33 does not sell or ship physical goods. If in the future we introduce physical products (e.g. printed workbooks), this policy will be updated with the applicable shipping terms.
    </p>

    <h2>7. Contact</h2>
    <p>
      For any question about access, cancellation or refunds, contact us at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
    </p>
  </LegalLayout>
);

export default DeliveryReturnsPage;
